import React, { useEffect, useState } from "react";
import classes from "../login/Login.module.css";
import { Link, useNavigate } from "react-router-dom";
import toast from "components/shared/toast/toast";
import { emailRegex } from "utils/regex";
import { CHANGE_PASSWORD, LOGIN } from "services/apiEndpoints";
import publicRequest from "services/publicRequest";
import eye from "assets/svg/eye.svg"
import eyeSlash from "assets/svg/eye-slash.svg"
import { getStock } from "redux/stockSlice";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

const initialValues = {
    password: "",
    confirmPassword: ""
}

const initialTouched = {
    password: false,
    confirmPassword: false
}

const NewPassword = (props) => {
    const dispatch = useDispatch()
    const location = useLocation()
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialValues);
    const [touched, setTouched] = useState(initialTouched);
    const navigate = useNavigate();
    const handleChange = (e, name) => {
        setValues({
            ...values,
            [name]: e.target.value
        });

        setErrors({
            ...errors,
            [name]: !e.target.value ? "This field is required" : ""
        })
    };
    const handleBlur = (e, name) => {
        setTouched({
            ...touched,
            [name]: true,
        });
    };
    const login = async (e) => {
        e.preventDefault()
        if (!values.password || !values.confirmPassword) {
            // Handle empty password fields
            setErrors({
                confirmPassword: !values.confirmPassword ? "This field is required" : "",
                password: !values.password ? "This field is required" : ""
            });
            setTouched({
                confirmPassword: true,
                password: true
            });
            return;
        }
        if (values.password !== values.confirmPassword) {
            // Handle mismatched passwords
            setErrors({
                confirmPassword: "Passwords do not match",
                password: "Passwords do not match"
            });
            setTouched({
                confirmPassword: true,
                password: true
            });
            return;
        } else {
            setErrors({
                confirmPassword: "",
                password: ""
            });
            setTouched({
                confirmPassword: false,
                password: false
            });
        }
        setIsSubmitting(true);
        try {
            const res = await publicRequest.post(CHANGE_PASSWORD, { password: values?.password, token: props?.code })
            toast.success("Reset Successful")
            navigate("/login")
        } catch (err) {
            toast.error("Invalid")
        }
        // try {
        //     const res = await publicRequest.post(LOGIN, values)
        //     localStorage.setItem("token", res?.data?.access)
        //     localStorage.setItem("username", values?.username)
        //     localStorage.setItem("refreshToken", res?.data?.refresh)
        //     localStorage.setItem("permission", JSON.stringify(res?.data?.apps))
        //     // localStorage.setItem("permission", JSON.stringify({ admin: true, trend: false, tracker: false }))

        //     // localStorage.setItem("email", values.email)
        //     // localStorage.setItem("userType", "trend")

        //     toast.success("Login Successful")
        //     navigate("/")
        // } catch (error) {
        //     toast.error("Invalid Email or Password")
        // }

        setIsSubmitting(false);
    };

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };
    const toggleShowPassword2 = () => {
        setShowPassword2(!showPassword2);
    };
    return (
        <div className={classes.mainContainer}>
            <div className={classes.effectDiv}>
                {/* <p className={classes.textInfo}>{displayText}</p> */}
            </div>

            <div className={classes.imageDiv}>
                <div className={classes.innerEffectDiv}>
                </div>
            </div>
            <div className={classes.shapeDiv}>
            </div>
            <form onSubmit={login} className={classes.loginForm}>
                <div className={classes.loginDiv}>
                    <p className={classes.loginHeading2}>Reset Password ?</p>
                    <div className={classes.inputField}>
                        <label htmlFor="password">Password <span className="required-mark">*</span></label>
                        <input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            placeholder="Password"
                            autoComplete="off"
                            value={values.password}
                            onChange={(e) => handleChange(e, "password")}
                            onBlur={(e) => handleBlur(e, "password")}
                        />
                        <div className={classes.eyeIcon} onClick={toggleShowPassword}>
                            {showPassword ?
                                <img src={eyeSlash} alt="show password" />
                                :
                                <img src={eye} alt="show password" />
                            }
                        </div>
                        {errors.password && touched.password ? (
                            <p className={classes.validationErrorText}>{errors.password}</p>
                        ) : (
                            ""
                        )}
                    </div>
                    <div className={classes.inputField}>
                        <label htmlFor="ConfirmPassword">Confirm Password <span className="required-mark">*</span></label>
                        <input
                            type={showPassword2 ? "text" : "password"}
                            name="confirmPassword"
                            placeholder="Confirm Password"
                            autoComplete="off"
                            value={values.confirmPassword}
                            onChange={(e) => handleChange(e, "confirmPassword")}
                            onBlur={(e) => handleBlur(e, "confirmPassword")}
                        />
                        <div className={classes.eyeIcon} onClick={toggleShowPassword2}>
                            {showPassword2 ?
                                <img src={eyeSlash} alt="show password" />
                                :
                                <img src={eye} alt="show password" />
                            }
                        </div>
                        {errors.confirmPassword && touched.confirmPassword ? (
                            <p className={classes.validationErrorText}>{errors.confirmPassword}</p>
                        ) : (
                            ""
                        )}
                    </div>
                    <button
                        className={classes.loginButton}
                        type="Reset Password"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? <span>Resetting <i className="fa fa-refresh fa-spin mx-2"></i></span> : "Reset Password"}
                    </button>
                </div>
            </form>

        </div>
    );
};

export default NewPassword;